import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-w', 'LetterW', [["path",{"d":"M4 4l4 16l4 -14l4 14l4 -16"}]]);